export const SET_DATASTORAGE_DATA = 'SET_DATASTORAGE_DATA';
export const ENTRYPOINT_STANDALONE = 'standalone';

export function setDataStorageData(dataStorage) {
  return {
    type: SET_DATASTORAGE_DATA,
    payload: dataStorage
  };
}

export function getDataStorageData(state) {
  return state.dataStorage;
}

export function getEntryPoint(state) {
  return state.dataStorage.entryPoint;
}

export function getIsInitializedViaPRS(state) {
  return (state.dataStorage.entryPoint && state.dataStorage.entryPoint !== ENTRYPOINT_STANDALONE);
}

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_DATASTORAGE_DATA:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
